import React from "react"
import * as S from "../elements"

interface Props {
  showBorder?: boolean
  onClickBack?: () => void
  onClose: () => void
}

export const SidebarHeader: React.FC<Props> = ({
  showBorder = true,
  onClickBack,
  onClose,
  children,
}) => {
  return (
    <S.HeaderEl showBorder={showBorder}>
      {onClickBack && (
        <S.Button onClick={onClickBack}>
          <S.BackEl />
        </S.Button>
      )}
      {children}
      <S.Button onClick={onClose}>
        <S.CloseEl />
      </S.Button>
    </S.HeaderEl>
  )
}
